var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        mobile: _vm.isMobile(_vm.$mq),
        "trial-paywall-container": _vm.onTrialPaywall
      }
    },
    [
      _c("div", { staticClass: "paywall-courses row paywall-section-gray" }, [
        !(_vm.onTrialPaywall && _vm.isMobile(_vm.$mq))
          ? _c("h2", [_vm._v("What can I learn on Brilliant?")])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "courses row" }, [
          _c(
            "div",
            { staticClass: "section-wrapper" },
            _vm._l(_vm.categorizedCoursesByDifficulty, function(ref) {
              var category = ref.category
              var courses_grouped_by_difficulty =
                ref.courses_grouped_by_difficulty
              return _c(
                "div",
                { key: category.id, staticClass: "section row course" },
                _vm._l(courses_grouped_by_difficulty, function(ref) {
                  var difficulty = ref.difficulty
                  var courses = ref.courses
                  return _c(
                    "div",
                    {
                      key: category.id + "-" + difficulty,
                      staticClass: "category"
                    },
                    [
                      _c("h3", { staticClass: "row" }, [
                        _vm._v(_vm._s(difficulty) + " " + _vm._s(category))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "unstyled row" },
                        _vm._l(courses, function(course) {
                          return _c(
                            "li",
                            { key: course.name },
                            [
                              _c("BriocheImageTag", {
                                attrs: {
                                  src: course.intro_image_url,
                                  width: 20,
                                  alt: course.name
                                }
                              }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(course.name) +
                                  "\n              "
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                0
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }